/**
 * Utility functions for offer description functionality
 */

const MAX_OFFER_DESCRIPTION_POSITION = 3

/**
 * Determines if a description should be shown for an offer based on position and filters
 * @param position - The position of the offer in the list (0-based)
 * @param query - Whether a natural language query is present
 * @returns true if description should be shown
 */
export function shouldShowOfferDescription(
  position: number | undefined,
  query: string | undefined
): boolean {
  return !!(
    query &&
    position !== undefined &&
    position < MAX_OFFER_DESCRIPTION_POSITION
  )
}
